import Super from './_transition';
import classic from 'ember-classic-decorator';

@classic
export default class SharedSkeletonContainerLoading extends Super {}
